module.exports = __webpack_public_path__ + "static/img/tv2.3ac2cd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/companies/marketmaker/assets/tv2.jpg
// module id = TgSW
// module chunks = 1